import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import moment from 'moment'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
    Avatar,
    Box,
    Card,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
    makeStyles,
    IconButton
} from '@material-ui/core'
import { Delete } from '@material-ui/icons'
import getInitials from '../../../utils/getInitials'

const useStyles = makeStyles((theme) => ({
    root: {},
    avatar: {
        marginRight: theme.spacing(2)
    }
}))

const Results = (props) => {
    const {
        className,
        pages,
        page,
        setPage,
        limit,
        setLimit,
        // appendNewUsers,
        // noMoreData,
        ...rest
    } = props
    const classes = useStyles()
    const [selectedCustomerIds, setSelectedCustomerIds] = useState([])
    const [shownUsers, setShownUsers] = useState()

    React.useEffect(() => {
        const _shownUsers = pages
            .slice(0 + limit * page, limit * (page + 1))
            .map((user) => user.id)

        setShownUsers(_shownUsers)
    }, [limit, page, pages])

    const handleSelectAll = (event) => {
        let newSelectedCustomerIds

        if (event.target.checked) {
            newSelectedCustomerIds = pages
                .slice(0 + limit * page, limit * (page + 1))
                .map((user) => user.id)
        } else {
            newSelectedCustomerIds = []
        }

        setSelectedCustomerIds(newSelectedCustomerIds)
    }

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedCustomerIds.indexOf(id)
        let newSelectedCustomerIds = []

        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds,
                id
            )
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(1)
            )
        } else if (selectedIndex === selectedCustomerIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, -1)
            )
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, selectedIndex),
                selectedCustomerIds.slice(selectedIndex + 1)
            )
        }

        setSelectedCustomerIds(newSelectedCustomerIds)
    }

    const handleLimitChange = (event) => {
        setLimit(event.target.value)
        if (event.target.value * page > pages.length) {
            const _newPage = Math.floor(pages.length / event.target.value)
            setPage(_newPage)
        }
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage)
    }

    return (
        <Card className={clsx(classes.root, className)} {...rest}>
            <PerfectScrollbar>
                <Box minWidth={1050}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={
                                            JSON.stringify(
                                                selectedCustomerIds
                                            ) === JSON.stringify(shownUsers)
                                        }
                                        color="primary"
                                        indeterminate={false}
                                        onChange={handleSelectAll}
                                    />
                                </TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Country</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Create/Update Date</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {pages
                                .slice(0 + limit * page, limit * (page + 1))
                                .map((user) => (
                                    <TableRow
                                        hover
                                        key={user.id}
                                        selected={selectedCustomerIds.includes(
                                            user.id
                                        )}
                                    >
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                checked={selectedCustomerIds.includes(
                                                    user.id
                                                )}
                                                onChange={(event) =>
                                                    handleSelectOne(
                                                        event,
                                                        user.id
                                                    )
                                                }
                                                value="true"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Box
                                                alignItems="center"
                                                display="flex"
                                            >
                                                <Avatar
                                                    className={classes.avatar}
                                                    src={user.photoURL}
                                                >
                                                    {getInitials(user.name)}
                                                </Avatar>
                                                <Typography
                                                    color="textPrimary"
                                                    variant="body1"
                                                >
                                                    {user.title}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            {user.countryName}
                                        </TableCell>
                                        <TableCell>
                                            {user.description}
                                        </TableCell>
                                        <TableCell>
                                            {moment(
                                                user?.createDate?.toDate()
                                            ).format('DD/MM/YYYY')}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton>
                                                <Delete />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </Box>
            </PerfectScrollbar>
            <TablePagination
                component="div"
                count={pages.length}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleLimitChange}
                page={page}
                rowsPerPage={limit}
                rowsPerPageOptions={[5, 10, 25]}
            />
        </Card>
    )
}

Results.propTypes = {
    className: PropTypes.string,
    pages: PropTypes.array.isRequired,
    limit: PropTypes.number,
    setLimit: PropTypes.func,
    page: PropTypes.number,
    setPage: PropTypes.func,
    appendNewUsers: PropTypes.func,
    noMoreData: PropTypes.bool
}

// Results.propTypes = {
//   className: PropTypes.string,
//   users: PropTypes.array.isRequired,
//   setPage: PropTypes.func,
//   page: PropTypes.number
// };

export default Results
